import React from 'react';
import Helmet from 'react-helmet';
import View from '../components/View';
import PostsListView from '../components/PostsListView';
import ContactView from '../components/ContactView';
import FooterView from '../components/FooterView';

const IndexPage = (props) => {
  const {
    data,
  } = props;
  const filters = [
    {
      title: 'Voir les sites vitrine',
      value: 'sites-vitrine',
    },
    {
      title: 'Voir les ecommerces',
      value: 'ecommerce',
    },
    {
      title: 'Voir les applications sur mesure',
      value: 'applications-sur-mesure',
    },
  ];
  return (
    <div>
      <Helmet
        title="Références eCommerce, site marchand, site vente en ligne - Com des Lézards"
      />
      <View colorMode="4">
        <PostsListView
          title="Ils nous ont fait confiance"
          titleColor="#4d12c7"
          subtitle="Derniers projets"
          subtitleColor="white"
          data={data}
          theme="dark"
          activeFilter="ecommerce"
          filters={filters}
        />
        <ContactView />
        <FooterView />
      </View>
    </div>

  );
};

export default IndexPage;

export const query = graphql`
  query references_ecommerce {
    allDatoCmsArticle(sort: {fields:[publicationDate], order:DESC}, filter: {
      articleType: {eq: "project"},
      tag: {eq: "ecommerce"}
    }) {
      ...previewArticle
    }
  }
  `;



// WEBPACK FOOTER //
// ./src/pages/references-ecommerce.jsx